import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"text-center"},[_c(VIcon,{staticClass:"my-3",attrs:{"size":"80","color":"red"}},[_vm._v("mdi-alert")]),_c('p',{staticClass:"ma-0 font-weight-medium text-red-900 font-16",domProps:{"innerHTML":_vm._s(_setup.props.infos.mensagem)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }